import { FunctionComponent } from "react";

export const NotFoundPage: FunctionComponent = () => <p>Not sure what that page is, sorry</p>;
